import { createFeatureSelector, createSelector } from '@ngrx/store';
import { messagesReducer } from './Messages.reducer';
import { IMessagesState } from '../state/IMessagesState';
import { ModuleConfiguration } from '../../messages.module.config';

export interface MessagesModuleState {
  messagesState: IMessagesState;
};

export const reducers = {
  messagesState: messagesReducer
};

export const getConfigurationState = createFeatureSelector( ModuleConfiguration.moduleName );

export const getMessagesState = createSelector(getConfigurationState, (s: MessagesModuleState) => s.messagesState);

export const getMessages = createSelector(getMessagesState, (s: IMessagesState) => s.messages);





// WEBPACK FOOTER //
// ./src/app/messages/store/reducers/index.ts